import React, {Component} from 'react';

class IconPump extends Component {
  render() {
    const {color, size} = this.props;
    const h = size === "lg"
      ? 128
      : 48;
    const w = size === "lg"
      ? 128
      : 48;
    return (<i className="emoji">
      <svg style={{
          fill: color
        }} className="emoji" viewBox="2 0 48 48" height={h} width={w} xmlns="http://www.w3.org/2000/svg">
          <path d="M 7 8 L 7 9 L 7 13 L 9 13 L 9 21 L 9 25 L 6 25 L 6 23 L 1 23 L 1 24 L 1 36 L 6 36 L 6 34 L 9 34 L 9 38 L 21 38 L 21 37.927734 C 21.328631 38.438635 21.711987 39.009649 22.175781 39.611328 C 22.78316 40.399279 23.485679 41.198591 24.271484 41.837891 C 25.05729 42.47719 25.948864 43 27 43 L 43 43 C 46.295455 43 49 40.295455 49 37 L 49 21 C 49 17.704545 46.295455 15 43 15 L 27 15 C 25.948864 15 25.05729 15.52281 24.271484 16.162109 C 23.485679 16.801409 22.78316 17.600721 22.175781 18.388672 C 21.711987 18.990351 21.328631 19.561365 21 20.072266 L 21 20 L 18 20 L 18 13 L 20 13 L 20 8 L 7 8 z M 9 10 L 18 10 L 18 11 L 9 11 L 9 10 z M 11 13 L 16 13 L 16 29 L 18 29 L 18 22 L 20 22 L 20 36 L 11 36 L 11 21 L 11 13 z M 28 17 L 42 17 L 42 41 L 28 41 L 28 40 L 41 40 L 41 38 L 28 38 L 28 36 L 41 36 L 41 34 L 28 34 L 28 32 L 41 32 L 41 30 L 28 30 L 28 28 L 41 28 L 41 26 L 28 26 L 28 24 L 41 24 L 41 22 L 28 22 L 28 20 L 41 20 L 41 18 L 28 18 L 28 17 z M 44 17.142578 C 45.719623 17.590208 47 19.142788 47 21 L 47 37 C 47 38.857212 45.719623 40.409792 44 40.857422 L 44 17.142578 z M 26 17.378906 L 26 40.621094 C 25.84984 40.527122 25.694135 40.418037 25.533203 40.287109 C 24.936196 39.801409 24.31059 39.100721 23.761719 38.388672 C 22.734395 37.055927 22.092291 35.874509 22 35.707031 L 22 22.292969 C 22.09229 22.125491 22.734395 20.944073 23.761719 19.611328 C 24.31059 18.899279 24.936196 18.198591 25.533203 17.712891 C 25.694135 17.581963 25.84984 17.472878 26 17.378906 z M 3 25 L 4 25 L 4 26 L 4 34 L 3 34 L 3 25 z M 6 27 L 9 27 L 9 32 L 6 32 L 6 27 z"/>
        </svg>
      </i>
    )
  }
};

export default IconPump;



// WEBPACK FOOTER //
// ./src/style/icon/IconPump.js